<template>
    <div v-if="json" id="all-blogs"  class="all-news-block">
        <div class="capper">
            <div class="capper-padded">
                <Lines type="allnews" label="Recent Blogs" />
                <!-- Conditional states: error, loading, no results -->
                <div v-if="searchError" class="error">
                    <div class="txt">
                        <span>An error has occurred. Please try later.</span>
                    </div>
                </div>
                <div v-else-if="searchLoading" class="news-links-loading">
                    <div class="txt">
                        <span>Loading</span>
                        <div class="ellipsis">
                            <div class="dot dot-1"></div>
                            <div class="dot dot-3"></div>
                            <div class="dot dot-2"></div>
                        </div>
                    </div>
                </div>
                <div v-else-if="searchResults !== null && !searchResults?.length" class="no-results">
                    <div class="txt">
                        <span>No results found.</span>
                    </div>
                </div>
                <!-- News Links -->
                <div v-else class="news-links">
                    <template v-for="(item, index) in newsToDisplay" :key="`news${index}`">
                        <!-- Add each blog category slug as a class, prefixed for clarity -->
                        <div :class="['news-link', ...item.blogCategories.map(cat => 'cat-' + cat.slug)]" data-aos="fade-up">
                            <div class="news-link2">
                                <div>
                                    <router-link :to="'/' + item.slug" :aria-label="item.title" >
                                        <div class="feaured-image imgover">
                                            <div
                                                v-if="item?.featuredNewsImage?.[0]?.bgStyle"
                                                class="bgimg"
                                                :style="item.featuredNewsImage[0].bgStyle"
                                            ></div>
                                            <TtmotifIcon v-else class="tt-motif-svg" aria-label="Insomniac" />
                                        </div>
                                        <span>{{item.title}}</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Lines from "@/components/pieces/Lines";
import { mapState } from "vuex";
//import Link from "@/components/pieces/Link.vue";
import gh from "@/helpers/gh";
import TtmotifIcon from "@/components/svgs/Ttmotif.vue";

export default {
    name: "AllNews",
    components: {
        TtmotifIcon,
        //Link,
        Lines,
    },
    props: {
        json: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            gh: gh,
            filteredNews: []
        };
    },
    computed: {
        ...mapState({
            selectedFilters: state => state.selectedFilters,
            searchResults: state => state.searchResults,
            searchLoading: state => state.searchLoading,
            searchError: state => state.searchError
        }),
        // If searchResults has items, use them; otherwise use the filtered news.
        newsToDisplay() {
            return this.filteredNews;
        }
    },
    mounted() {
        this.applyFilters();
    },
    methods: {
        applyFilters() {
            // If the "all" filter is checked, clear search results and use the full JSON.
            if (this.selectedFilters.some(filter => filter.slug === "all")) {
                // Clear search results; adjust this commit to match your Vuex implementation.
                this.$store.commit('SET_SEARCH_RESULTS', null);
                this.filteredNews = this.json;
            } else {
                // Use searchResults as the base if they exist, otherwise use the full JSON.
                const baseNews = (this.searchResults && this.searchResults.length)
                    ? this.searchResults
                    : this.json;

                // If no filters are selected, show only the first 8 items.
                if (this.selectedFilters.length === 0) {
                    this.filteredNews = baseNews.slice(0, 8);
                } else {
                    // Otherwise, filter the base list using the active filters.
                    this.filteredNews = baseNews.filter(item => {
                        return item.blogCategories.some(cat =>
                            this.selectedFilters.some(filter => filter.slug === cat.slug)
                        );
                    });
                }
            }
            // Refresh animations if needed.
            setTimeout(this.gh.aosRefresh, 100);
            this.gh.aosRefresh();
        }
    },
    watch: {
        selectedFilters: {
            handler() {
                this.applyFilters();
            },
            deep: true
        },
        searchResults: {
            handler() {
                this.applyFilters();  // add this line
                this.gh.aosRefresh();
                setTimeout(this.gh.aosRefresh, 100);
            },
            deep: true
        }
    },
};
</script>